var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1240,
    height: 600,
    viewBox: "0 0 1240 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_6250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1171.5,
    cy: 127.5,
    r: 12.5,
    fill: "#43B97F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.5,
    cy: 553.5,
    r: 10.5,
    fill: "#4C90F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 539.5,
    r: 10.5,
    fill: "#FF6650"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.5,
    cy: 42.5,
    r: 13.5,
    fill: "#C280D2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.5,
    cy: 507.5,
    r: 10.5,
    fill: "#FFB951"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_6250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1240,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLine);
export default __webpack_public_path__ + "static/media/BackgroundLine.8a9944a643c4163dae8e3cac5a7c14e2.svg";
export { ForwardRef as ReactComponent };